<script setup lang="ts">
// Déclare la prop reçue
const props = defineProps<{
    step: {
        title: string
        description: string
    }
}>()
</script>

<template>
    <h2 class="text-2xl font-bold text-[#7b0f14]">{{ step?.title }}</h2>
    <div
        class="mb-4 prose prose-indigo max-w-none"
        v-html="step?.description"
    ></div>
</template>

<style scoped>

</style>
